<template>
  <div>
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide>
        <div class="product R1BG">
          <div class="gda"><img src="/static/img/gda.png" alt="" /></div>
          <div class="protips">
            <div class="proname">蓝鲨 R 系列</div>
            <div class="procontent">用汽车科技创造智能电动摩托车</div>
            <div class="proinfobox">
              <div class="proinfo ">
                <div class="leftInfo">
                  <span class="fs_normal">
                    110
                    <span class="fs_tiny">km</span>
                  </span>
                  <br /><span class="fs_tiny">NEDC 续航⾥程</span>
                </div>
                <div>
                  <span class="fs_normal">动⼒ + 系统控制域</span><br />
                  <span class="fs_tiny">
                    汽⻋级双域智能中控系统
                  </span>
                </div>
              </div>
              <div class="proinfo">
                <div class="leftInfo">
                  <span class="fs_normal">
                    80 <span class="fs_tiny">km/h</span>
                  </span>
                  <br /><span class="fs_tiny">最高速度</span>
                </div>
                <div>
                  <span class="fs_normal ">
                    <span class="fs_normal">ArkRide</span> OS 2.0
                  </span>
                  <br /><span class="fs_tiny">蓝鲨车载智能操作系统</span>
                </div>
              </div>
            </div>
            <div class="probtn" @click="goR1Product">了解详情</div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="product H1BG">
          <div class="protips">
            <div class="proname">蓝鲨 H1</div>
            <div class="procontent"></div>
            <div class="proinfobox">
              <div class="proinfo ">
                <div class="leftInfo">
                  <span class="fs_normal">
                    60
                    <span class="fs_tiny">km</span>
                  </span>
                  <br /><span class="fs_tiny">工况续航</span>
                </div>
                <div class="leftInfo">
                  <span class="fs_normal">
                    27
                    <span class="fs_tiny">%</span>
                  </span>
                  <br /><span class="fs_tiny">爬坡能力</span>
                </div>
                <div class="leftInfo">
                  <span class="fs_normal">
                    145
                    <span class="fs_tiny">N·m</span>
                  </span>
                  <br /><span class="fs_tiny">轮上扭矩</span>
                </div>
              </div>
              <div class="proinfo">
                <div class="leftInfo">
                  <span class="fs_normal">
                    1,440<span class="fs_tiny">Wh</span>
                  </span>
                  <br /><span class="fs_tiny">电池容量</span>
                </div>
                <div>
                  <span class="fs_normal ">
                    <span class="fs_normal">ArkRide</span> OS 2.0
                  </span>
                  <br /><span class="fs_tiny">智能车机系统</span>
                </div>
              </div>
            </div>
            <div class="probtn" @click="goH1Product">了解详情</div>
          </div>
        </div></swiper-slide
      >
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  name: '',
  data() {
    return {
      swiperOption: {
        loop: true, // 无限循环
        autoplay: {
          // 自动切换
          delay: 3000,
          stopOnLastSlide: false, // 切换到最后一个slide时停止自动切换
          disableOnInteraction: false // 用户操作swiper之后，是否禁止自动切换。默认为true
        },
        resistanceRatio: 0,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  created() {},
  methods: {
    goR1Product() {
      this.$router.push('/cn/robor')
    },
    goH1Product() {
      this.$router.push('/cn/h1')
    }
  },
  mounted() {},
  computed: {},
  components: {
    swiper,
    swiperSlide
  }
}
</script>
<style lang="less" scoped>
@import '../../assets/css/common.less';
.R1BG {
  background-image: url(/static/img/home_bg.png);
}
.H1BG {
  background-image: url(/static/img/home_H1bg.jpg);
}
.product {
  width: 100%;
  height: 43.646vw;
  // background-image: url(/static/img/home_bg.png);
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  .gda {
    position: absolute;
    top: 4.688vw;
    right: 7.188vw;
  }
  .protips {
    position: absolute;
    top: 12.24vw;
    left: 20vw;
    font-weight: bold;
    .proname {
      font-size: 2.5vw;
      margin-bottom: 1.042vw;
      line-height: 2.083vw;
      font-weight: 500;
    }
    .procontent {
      margin-bottom: 1.823vw;
      height: 1.667vw;
      font-size: 1.25vw;
      font-weight: 400;
    }

    .proinfobox {
      margin-bottom: 3.49vw;
      .proinfo {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 1.25vw;
        margin-bottom: 1.458vw;
      }
      .leftInfo {
        width: 7.031vw;
      }
    }
    .probtn {
      width: 12.5vw;
      height: 2.344vw;
      border-radius: 1.172vw;
      line-height: 2.135vw;
      font-size: 0.833vw;
      text-align: center;
      border: 0.104vw solid #fff;
      cursor: pointer;
      box-sizing: border-box;
    }
  }
}
.swiper-pagination {
  bottom: 3.49vw;
  /deep/ .swiper-pagination-bullet {
    margin: 0 0.417vw;
    width: 0.729vw;
    height: 0.729vw;
  }
  /deep/ .swiper-pagination-bullet-active {
    background: url(/static/img/swiperActive.png) no-repeat 100% / cover !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/swiper/swiper1.vue